import { Entity } from 'typeorm';
import { StateEntity } from './state-entity.class';

@Entity()
export class PublicHolidayStateEntity extends StateEntity {}
